"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Oct 09 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * BindDTOConverter
 *
 * @author RV
 */


var BindDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(BindDTOConverter, _DataObjectConverter_);

  function BindDTOConverter() {
    _classCallCheck(this, BindDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(BindDTOConverter).apply(this, arguments));
  }

  return BindDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.BindDTOConverter = BindDTOConverter;